import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { CustomerInterestService } from './customer-interest.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-customer-interest',
  templateUrl: './customer-interest.component.html',
  styleUrls: ['./customer-interest.component.css'],
})
export class CustomerInterestComponent implements OnInit {
  isLoading = new BehaviorSubject<boolean>(false);
  displayedColumns: string[] = [
    'SNo',
    'interest',
    'createdAt',
    'updatedAt',
    'status',
    'action',
  ];
  bucketurl = environment.bucketUrl;
  public ELEMENT_DATA: any[] = [];
  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false; // Track form submission
  public selectedId: number | null = null;
  customerInterestForm: FormGroup;
  dataSource = new MatTableDataSource<any>(this.ELEMENT_DATA);

  constructor(
    private customerInterestService: CustomerInterestService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) {
    this.customerInterestForm = this.fb.group({
      status: ['', Validators.required],
      interest: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.getCustomerInterestMaster();
  }

  get f() {
    return this.customerInterestForm.controls;
  }

  back() {
    this.clearForm();
    this.isCreate = false;
    this.isEdit = false;
    this.submitted = false; // Reset submitted flag
    this.getCustomerInterestMaster();
  }

  clearForm() {
    this.submitted = false;
    this.customerInterestForm.reset(); // Reset the form
    this.selectedId = null;
  }

  getCustomerInterestMaster() {
    this.isLoading.next(true);
    this.customerInterestService.getCustomerInterestMaster().subscribe(
      (response) => {
        this.ELEMENT_DATA = response.body.data;
        this.dataSource.data = this.ELEMENT_DATA;
        this.isLoading.next(false);
      },
      (error) => {
        this.isLoading.next(false);
      }
    );
  }

  onSubmit() {
    this.submitted = true;

    if (this.customerInterestForm.invalid) {
      return;
    }

    this.isLoading.next(true);

    if (this.isEdit) {
      if (this.selectedId !== null) {
        this.customerInterestService
          .updatecustomerInterestMaster(
            this.selectedId,
            this.customerInterestForm.value
          )
          .subscribe(
            (response) => {
              if(response.body.responseCode ==200){
              this.toastr.success('Customer Interest updated successfully');
              this.clearForm();
              this.isEdit = false;
              this.getCustomerInterestMaster();
              this.isLoading.next(false);
            }else{
              this.isLoading.next(false);
              this.toastr.error(response.body.responseMessage);
            }
            },
            (error) => {
              this.toastr.error('Error updating Customer Interest');
              this.isLoading.next(false);
            }
          );
      }
    } else {
      this.customerInterestService
        .createCustomerInterestMaster(this.customerInterestForm.value)
        .subscribe(
          (response) => {
            if(response.body.responseCode ==200){
            this.toastr.success('Customer Interest created successfully');
            this.clearForm();
            this.isCreate = false;
            this.getCustomerInterestMaster();
            this.isLoading.next(false);
            }else{
              this.isLoading.next(false);
              this.toastr.error(response.body.responseMessage);
            }
          },
          (error) => {
            this.toastr.error('Error creating Customer Interest');
            this.isLoading.next(false);
          }
        );
    }
  }

  edit(element: any) {
    this.isEdit = true;
    this.selectedId = element.id;
    this.customerInterestForm.patchValue({
      status: element.status ? 1 : 0,
      interest: element.interest,
    });
  }

  public searchInput = new FormControl("");
  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const interest = data.interest.toLowerCase().includes(filter);
      return interest;
    };
      this.dataSource.filter = filterValue;
  }
   clearSearch() {
    this.searchInput.setValue('');
    this.applyFilter();
  }
}
